// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-catalog-search',
    // #endregion
    // #region Properties
    data: () => ({
        categories: [],
        products: [],
        pageSize: 3,
        recordCount: 0,
        isLoading: false,
        isMounted: false
    }),
    computed: {
        searchText() {
            return this.$route.query.q;
        },
    },
    // #endregion
    // #region Boostrap
    created() {
        this.loadData();
    },
    beforeMount() {
        this.isMounted = true;
        this.$host.eventBus.on('refresh', this.loadData);
    },
    beforeUnmount() {
        this.isMounted = false;
        this.$host.eventBus.off('refresh', this.loadData);
    },
    // #endregion
    // #region Watch
    watch: {
        "$route.query"(value) {
            nextTick(() => {
                if (this.isMounted) {
                    this.loadData();
                }
            });
        },
    },
    // #endregion
    // #region Core
    methods: {
        async loadData() {
            // #region Check
            if (utils.isEmpty(this.searchText)) {
                return;
            }
            // #endregion
            // #region Loading
            this.isLoading = true;
            // #endregion
            // #region Load
            host.api.get(`commerce/catalog/search`, { params: this.$route.query })
                .then((e) => {
                // #region Breadcrumb
                if (e?.data?.breadcrumb) {
                    this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumb);
                }
                // #endregion
                // #region Data
                this.categories = e.data.categories ?? [];
                this.products = e.data.products ?? [];
                this.pageSize = e.data.pagination?.pageSize ?? 0;
                this.recordCount = e.data.pagination?.totalRecords ?? 0;
                // #endregion
                //Internal
                this.isLoading = false;
            })
                .catch((e) => {
                this.isLoading = false;
                host.notification.showToast(e.message);
            });
            // #endregion
        },
        OnRefresh(event) {
            //Default
            event.preventDefault();
            //Notify
            this.$host.eventBus.emit('refresh');
        }
    }
    // #endregion
});
// #endregion
